<p-dialog
  header="Programmer sur EROS"
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '560px' }"
  styleClass="pool-schedule-dialog"
  (visibleChange)="!$event && close()"
  (onHide)="close()"
>
  @if (context) {
    <div class="schedule-form">
      <!-- Récap affaire -->
      <div class="affair-recap">
        <div class="ar-name">
          <i class="pi pi-user"></i>
          {{ context.affair.customerLastname || context.affair.affairName }}
        </div>
        <div class="ar-address">
          <i class="pi pi-map-marker"></i>
          {{
            [
              context.affair.address,
              context.affair.postalCode,
              context.affair.locality
            ]
              .join(' ')
              .trim()
          }}
        </div>
      </div>

      <!-- Créneaux proposés -->
      <div class="field">
        <label>Créneau</label>
        <ul class="proposal-list">
          @for (proposal of context.proposals; track proposal.id) {
            <li
              [class.is-selected]="selectedProposal?.id === proposal.id"
              (click)="selectProposal(proposal)"
            >
              <span class="pl-radio">
                <i
                  class="pi"
                  [class.pi-circle]="selectedProposal?.id !== proposal.id"
                  [class.pi-check-circle]="selectedProposal?.id === proposal.id"
                ></i>
              </span>
              <span class="pl-date">{{ formatFullDate(proposal.date) }}</span>
              <span class="pl-time">{{ formatProposalTime(proposal) }}</span>
              <span class="pl-tech">
                <i class="pi pi-user"></i>
                {{ proposal.technicianName }}
              </span>
            </li>
          }
        </ul>
      </div>

      <div class="field-row">
        <!-- Heure d'arrivée ajustable -->
        <div class="field time-field">
          <label for="psd-time">Heure</label>
          <input
            id="psd-time"
            type="time"
            pInputText
            [ngModel]="startTime"
            (ngModelChange)="onStartTimeChange($event)"
          />
        </div>

        <!-- Agence (filtrée par la source ERP du technicien) -->
        <div class="field agency-field">
          <label for="psd-agency">
            Agence *
            @if (erpSource) {
              <span class="erp-badge">{{ erpSource }}</span>
            }
          </label>
          <p-dropdown
            inputId="psd-agency"
            [options]="agencies"
            [(ngModel)]="selectedAgencyId"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            filterBy="name,locality,postalCode"
            [virtualScroll]="true"
            [virtualScrollItemSize]="38"
            [loading]="agenciesLoading"
            [resetFilterOnHide]="true"
            [autofocusFilter]="true"
            placeholder="Sélectionner l'agence"
            appendTo="body"
            styleClass="w-full"
          ></p-dropdown>
        </div>
      </div>

      <!-- Plage horaire annoncée au client (isTimeSlot) -->
      <label class="confirm-toggle">
        <input
          type="checkbox"
          [ngModel]="isTimeSlot"
          (ngModelChange)="onTimeSlotToggle($event)"
        />
        Plage horaire annoncée au client
      </label>

      @if (isTimeSlot) {
        <div class="field-row time-slot-row">
          <div class="field time-field">
            <label for="psd-slot-start">Entre</label>
            <input
              id="psd-slot-start"
              type="time"
              pInputText
              [(ngModel)]="startTimeSlot"
            />
          </div>
          <div class="field time-field">
            <label for="psd-slot-end">Et</label>
            <input
              id="psd-slot-end"
              type="time"
              pInputText
              [(ngModel)]="endTimeSlot"
            />
          </div>
          @if (
            startTimeSlot && endTimeSlot && startTimeSlot >= endTimeSlot
          ) {
            <small class="field-error">
              La fin de plage doit être après le début.
            </small>
          }
        </div>
      }

      <label class="confirm-toggle">
        <input type="checkbox" [(ngModel)]="isConfirmed" />
        Intervention confirmée avec le client
      </label>

      <!-- Coordonnées client (optionnel) -->
      <button
        type="button"
        class="advanced-toggle"
        (click)="showCustomerDetails = !showCustomerDetails"
      >
        <i
          class="pi"
          [class.pi-chevron-right]="!showCustomerDetails"
          [class.pi-chevron-down]="showCustomerDetails"
        ></i>
        Coordonnées client (optionnel)
      </button>

      @if (showCustomerDetails) {
        <div class="field-row">
          <div class="field">
            <label for="psd-firstname">Prénom</label>
            <input
              id="psd-firstname"
              type="text"
              pInputText
              [(ngModel)]="customerFirstname"
            />
          </div>
          <div class="field">
            <label for="psd-phone">Téléphone</label>
            <input
              id="psd-phone"
              type="tel"
              pInputText
              [(ngModel)]="customerPhone"
            />
          </div>
        </div>
        <div class="field">
          <label for="psd-email">Email</label>
          <input
            id="psd-email"
            type="email"
            pInputText
            [(ngModel)]="customerEmail"
          />
        </div>
      }

      @if (partialFailure) {
        <div class="partial-failure">
          <i class="pi pi-exclamation-triangle"></i>
          <div>
            <p>
              L'affaire <strong>{{ partialFailure.mlRef }}</strong> a été créée
              dans EROS, mais la création de l'intervention a échoué.
            </p>
            <p>Cliquez sur « Réessayer » pour reprendre sans doublon.</p>
          </div>
        </div>
      }

      @if (submitError) {
        <p class="submit-error">
          <i class="pi pi-exclamation-circle"></i>
          {{ submitError }}
        </p>
      }
    </div>
  }

  <ng-template pTemplate="footer">
    <p-button
      label="Annuler"
      severity="secondary"
      [outlined]="true"
      [disabled]="submitting"
      (click)="close()"
    ></p-button>
    <p-button
      [label]="partialFailure ? 'Réessayer' : 'Créer sur EROS'"
      icon="pi pi-bolt"
      [loading]="submitting"
      [disabled]="!canSubmit"
      (click)="submit()"
    ></p-button>
  </ng-template>
</p-dialog>
